import { User } from 'features/users/types'

export interface CommentContentCommon {
  content: string
  mentions: CommentUserInfo[]
  author: CommentUserInfo

  read?: boolean

  /**
   * `true` If comment content was edited by user.
   */
  edited?: boolean
  updatedAt: string
  createdAt: string
}

export interface Comment extends CommentContentCommon {
  id: string
  resolved?: boolean
  read?: boolean
  responsesCount?: number
  sequenceNumber: number
}

export enum CommentResponseActionType {
  Reply = 'reply',
  Resolved = 'resolved',
  Reopened = 'reopened'
}

export interface CommentResponse extends CommentContentCommon {
  id: string // id of this particular response
  commentId: string // id of parent comment
  actionType?: CommentResponseActionType
}

export interface CommentWithResponses extends Comment {
  responses: CommentResponse[]
}

export interface CommentUserInfo {
  id: string // user id
  email?: string
  avatar?: string // avatar url
  deactivated?: boolean
}

export type CommentUser = User & {
  /**
   * `true` If user has no access in given context (like map).
   *
   * Example user commented on map, his comment is visible in map, but then map become private.
   */
  noAccess?: boolean

  /**
   * `true` If user is the owner of given resource (like map).
   */
  isOwner?: boolean
}

export enum CommentFilterType {
  All = 'all',
  MyComments = 'myComments',
  OnlyUnread = 'onlyUnread'
}
export interface CommentFilter {
  filter: CommentFilterType
  searchText: string
  currentUserId?: string
  showResolved: boolean
}

export type CommentAction = 'delete' | 'toggleResolved' | 'edit' | 'copyLink'
export type TakeOverResult = 'locked' | 'denied' | 'cancel' | 'conflict'
export type TakeResponseDialogResult = 'accepted' | 'rejected' | 'canceled'
export const TAKEOVER_TIMEOUT_SEC = 30
